<template>
    <div class="content-heading">
        <em class="ic-head-icon">
            <img src="@/assets/images/sidebar/design.svg" alt="Design Icon">
        </em>
        <h4 class="head-title">Design</h4>
        <em class="ic-tooltip" id="help"></em>
        <b-popover target="help"
                triggers="hover"
                content="Craft and personalize your website according to your vision, with simple customization to embody your brand's essence.">
        </b-popover>
        <div class="head-tabs">
            <b-nav tabs ref="designNav">
                <template v-if="isGLifeChannelEnabled">
                    <b-nav-item :to="{ path: '/design/glife'}" v-if="permission.hasAccess('design.glife')">
                        GLife
                    </b-nav-item>
                </template>
                <template v-if="isAppChannelEnabled">
                    <b-nav-item :to="{ path: '/design/app'}" v-if="permission.hasAccess('design.app')">
                        App
                    </b-nav-item>
                </template>
                <template v-if="isWebChannelEnabled">
                    <b-nav-item :to="{ path: '/design/web' }" v-if="permission.hasAccess('design.web')">
                        Web
                    </b-nav-item>
                </template>
                <template v-if="isEstoreExecution">
                    <b-nav-item :to="{ path: '/design/estorebanner' }" v-if="permission.hasAccess('design.estore-banner')">
                        E-Store Banner
                    </b-nav-item>
                </template>
                <b-nav-item :to="{ path: '/design/advanced-settings' }" v-if="permission.hasAccess('design.advanced-settings')">
                    Advanced Settings
                </b-nav-item>
            </b-nav>
        </div>
    </div>
</template>

<script>
import permission from "@/services/user.permission";
import { mapGetters } from "vuex";
export default {
    name: "design-nav",
    data() {
        return {
            msg: "Design Nav",
            permission: permission,
            env: process.env.VUE_APP_MODE
        };
    },
    computed: {
        ...mapGetters("accountProfile", [
            "planExecutions",
            "isWebChannelEnabled",
            "isAppChannelEnabled",
            "isGLifeChannelEnabled"
        ]),
        isEstoreExecution: {
            get() {
                return !!this.planExecutions.enable_estore;
            },
            set(status) {
                return status;
            }
        }
    },
    created() {
        setTimeout(() => {
            const host = window.document.location.host;
            const designNavChildren = this.$refs.designNav.children;
            const available_routes = Object.keys(designNavChildren)
                .map(childKey => designNavChildren[childKey].children[0].href.split(host).pop());
            const redirect_route = available_routes[0].split(host).pop();
            const transformed_pathname = window.document.location.pathname.split('/').slice(0, 3).join('/');

            if (!available_routes.includes(transformed_pathname))
                this.$router.push({ path: redirect_route });
        }, 300);
    }
    
};
</script>
